import { useForm } from "@tanstack/react-form"

import { Field } from "@/components/ui/Field"
import { Textarea } from "@/components/ui/Textarea"

interface PracticeTopicStepProps {
  value: string
  onChange: (value: string) => void
  onValidation?: (isValid: boolean) => void
}

export function PracticeTopicStep({
  value,
  onChange,
  onValidation,
}: PracticeTopicStepProps) {
  const form = useForm({
    defaultValues: {
      practiceTopic: value,
    },
  })

  return (
    <div className="tw-text-center tw-space-y-6">
      <h2 className="tw-text-3xl tw-pb-3 tw-font-bold tw-text-gray-800">
        What are students learning today?
      </h2>

      <span className="tw-text-sm tw-text-gray-600 tw-max-w-3xl tw-mx-auto">
        <span className="tw-font-semibold">💡 Tip:</span> Enter what should
        students practice? You can include standards, difficulty level,
        language, and question types.
      </span>

      <form.Field name="practiceTopic">
        {(field) => (
          <Field>
            <Textarea
              id={field.name}
              value={field.state.value}
              onBlur={() => {
                field.handleBlur()
                onChange(field.state.value)
              }}
              onChange={(e) => {
                field.handleChange(e.target.value)
                onChange(e.target.value)
              }}
              placeholder="e.g: 20 problems on equivalent ratios (CCSS.Math.Content.6.RP.A.3.a), progressively harder, in English and Spanish, mix of multiple choice and open-ended"
              rows={9}
              className="tw-w-full tw-max-w-3xl tw-mx-auto tw-px-6 tw-py-4 tw-border-2 tw-border-dashed tw-rounded-sm tw-text-center tw-text-base tw-text-gray-500 placeholder:tw-text-gray-400 placeholder:tw-whitespace-pre-line tw-transition-all tw-resize-none focus:tw-outline-none focus:tw-ring-2 tw-border-emerald-600 focus:tw-border-emerald-600 focus:tw-ring-emerald-600"
            />
          </Field>
        )}
      </form.Field>
    </div>
  )
}
